"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _text = _interopRequireDefault(require("@waglabs/text"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AutocompleteOption = (0, _styledComponents.default)(_text.default)(_templateObject(), function (props) {
  return props.isHighlighted && "\n    background-color:  " + props.theme.colors.backgroundGray + ";\n  ";
});

var TextInputAutocomplete =
/*#__PURE__*/
function (_react$Component) {
  _inheritsLoose(TextInputAutocomplete, _react$Component);

  function TextInputAutocomplete() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _react$Component.call.apply(_react$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleRef", function (ref) {
      return function (inputRef) {
        var onRef = _this.props.onRef;

        if (ref) {
          ref(inputRef);
        }

        if (onRef) {
          onRef(inputRef);
        }
      };
    });

    return _this;
  }

  var _proto = TextInputAutocomplete.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        form = _this$props.form,
        items = _this$props.items,
        label = _this$props.label,
        _this$props$inputProp = _this$props.inputProps,
        inputProps = _this$props$inputProp === void 0 ? {} : _this$props$inputProp,
        onBlur = _this$props.onBlur,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onSelect = _this$props.onSelect,
        type = _this$props.type,
        value = _this$props.value,
        _renderInput = _this$props.renderInput,
        autocompleteMenuProps = _this$props.autocompleteMenuProps,
        props = _objectWithoutPropertiesLoose(_this$props, ["form", "items", "label", "inputProps", "onBlur", "onChange", "onFocus", "onSelect", "type", "value", "renderInput", "autocompleteMenuProps"]);

    return _react.default.createElement(_reactAutocomplete.default, {
      getItemValue: function getItemValue(item) {
        return item.label;
      },
      renderMenu: function renderMenu(menuItems) {
        if (!items.length) {
          return _react.default.createElement("div", null);
        }

        return _react.default.createElement(_flex.default, _extends({
          bg: "white",
          border: "1px solid",
          borderColor: "wagGray",
          borderRadius: [2],
          flexDirection: "column",
          height: ['125px'],
          overflow: "auto",
          position: "absolute",
          top: "30px",
          width: "100%",
          zIndex: "1"
        }, autocompleteMenuProps), menuItems);
      },
      renderItem: function renderItem(item, isHighlighted) {
        return _react.default.createElement(AutocompleteOption, {
          isHighlighted: isHighlighted,
          key: item.key,
          m: "0",
          p: [2],
          px: [3]
        }, item.label);
      },
      renderInput: function renderInput(_ref) {
        var ref = _ref.ref,
            restInputProps = _objectWithoutPropertiesLoose(_ref, ["ref"]);

        return _react.default.createElement(_react.default.Fragment, null, _renderInput && _renderInput(Object.assign({
          label: label,
          type: type,
          value: value,
          onRef: _this2.handleRef(ref)
        }, props, {}, restInputProps)), !_renderInput && _react.default.createElement(_.TextInputField, _extends({
          label: label,
          type: type,
          value: value
        }, props, restInputProps, {
          onRef: _this2.handleRef(ref)
        })));
      },
      wrapperStyle: {
        width: '100%',
        position: 'relative'
      },
      inputProps: inputProps,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      items: items,
      value: value,
      onSelect: onSelect
    });
  };

  return TextInputAutocomplete;
}(_react.Component);

var _default = TextInputAutocomplete;
exports.default = _default;